<script setup lang="ts">
import type { ArticleV1 } from '@ilteducation/content-registry-types';
import RelatedContent from '@/components/related-content/RelatedContent.vue';
import useSimilarContentContext from '@/composables/use-similar-content-context';
import { configHelper } from '@ilteducation/config';
import { computed } from 'vue';
import { useClientAnalytics } from '@ilteducation/client-analytics';

type Props = {
  contentIds: string[];
  contextKey: string;
};

const props = defineProps<Props>();
const contentIds = computed(() => props.contentIds);
const contextKey = computed(() => `${props.contextKey}-articles`);

const { relatedContents: relatedArticles, isLoading } = useSimilarContentContext<ArticleV1>(
  contextKey,
  contentIds,
  'ArticleV1',
);
const { sendAnalyticsEvent } = useClientAnalytics();

const articlesUrl = configHelper.getAppUrl('artiklar.begreppa');
const onOpen = (id: string) => {
  const url = `${articlesUrl}/view/${id}?reauthenticate=auto`;
  sendAnalyticsEvent('AppUserEventType', {
    eventName: 'PageNavigation',
    metadata: {
      to: url,
      from: window.location.pathname,
    },
  });
  window.open(url, '_blank')!.focus();
};
</script>

<template>
  <v-row v-if="!isLoading" class="pb-6 pt-4">
    <v-col cols="12">
      <RelatedContent
        :related-articles="relatedArticles as ArticleV1[]"
        :show-header="false"
        :show-no-related-articles-text="false"
        :show-publisher-info="true"
        @openArticle="onOpen"
      />
    </v-col>
  </v-row>
  <v-row v-else>
    <v-col v-for="index in 4" :key="index">
      <v-skeleton-loader height="250px" type="ossein"></v-skeleton-loader>
    </v-col>
  </v-row>
</template>

<style lang="scss" scoped>
:deep(.v-card--variant-elevated) {
  background: inherit;
}
</style>
